<template>
  <div class="unit-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Lista de unidades</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <div class="mb-4">
          <b-row class="mb-2">
            <b-col>
              <label class="cj-label">Buscar</label>
              <b-form-input type="text" v-model="unitFilterForm.name" @keyup.enter="getUnits(1)"></b-form-input>
            </b-col>
            <b-col>
              <label class="cj-label">Principal</label>
              <multiselect v-model="unitFilterForm.is_default" :options="defaultOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="false" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="unitFilterForm.is_default != null" @mousedown.prevent.stop="unitFilterForm.is_default = null"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Meio de pagamento integrado</label>
              <multiselect v-model="unitFilterForm.status" :options="statusOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="false" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="unitFilterForm.status != null" @mousedown.prevent.stop="unitFilterForm.status = null"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label">Plano com antecipação</label>
              <multiselect v-model="unitFilterForm.zoop_anticipation_enabled" :options="defaultOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="false" placeholder="Selecione">
                <template slot="clear">
                  <div class="multiselect__clear" v-if="unitFilterForm.zoop_anticipation_enabled != null" @mousedown.prevent.stop="unitFilterForm.zoop_anticipation_enabled = null"></div>
                </template>
              </multiselect>
            </b-col>
            <b-col>
              <label class="cj-label w-100">&nbsp;</label>
              <b-button variant="primary" block @click="getUnits(1)"><i class="far fa-search"></i> Filtrar</b-button>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de unidades</p>
                  <p class="title"><small>{{ pagination.total }} unidades cadastradas</small></p>
                </div>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table">
                  <thead>
                    <tr>
                      <th>Cliente</th>
                      <th>Nome</th>
                      <th>CPF / CNPJ</th>
                      <th>Estado</th>
                      <th>Cidade</th>
                      <th>E-mail</th>
                      <th>Principal</th>
                      <th>Meio de pagamento integrado</th>
                      <th>Plano</th>
                      <th>C/ antecipação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <router-link tag="tr" :to="'/'+url+'/'+unit.id" v-for="unit in units" :key="unit.id">
                      <td>{{ unit.client }}</td>
                      <td>{{ unit.display_name }}</td>
                      <td>{{ unit.display_document }}</td>
                      <td>{{ unit.state }}</td>
                      <td>{{ unit.city }}</td>
                      <td>{{ unit.display_email }}</td>
                      <td>{{ unit.is_default ? 'Sim' : 'Não' }}</td>
                      <td class="unit-status"><i class="fa fa-circle mr-2" :class="'status-indicator ' + getStatus(unit).class"></i>{{getStatus(unit).name}}</td>
                      <td>{{ unit.zoop_plan_id }}</td>
                      <td>{{ unit.zoop_anticipation_enabled ? 'Sim' : 'Não' }}</td>
                    </router-link>
                  </tbody>
                </table>
                <p v-if="units.length == 0" class="text-center sub-title">A sua busca por unidades não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getUnits"></b-pagination>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: 'unidades',
        // newTerm: '',
        module: 'units',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canEdit: true,

        units: [],

        defaultOptions: [
          { value: true, name: 'Sim' },
          { value: false, name: 'Não' }
        ],

        statusOptions: [
          { value: 'incomplete', name: 'Não cadastrado' },
          { value: 'pending', name: 'Em análise' },
          { value: 'enabled', name: 'Habilitado' },
          { value: 'deleted', name: 'Excluído' },
          { value: 'disabled', name: 'Desabilitado' },
        ],

        unitFilterForm: {
          name: null,
          is_default: null,
          status: null,
          zoop_anticipation_enabled: null
        }
      }
    },
    mounted () {
      this.eventBus.$emit('IS_LOADING', true);

      // this.newTerm = 'cadastrar-cliente';

      this.canSee = true;
      this.canEdit = true;

      this.getUnits(this.pagination.currentPage);
    },
    methods: {
      getUnits(page) {
        let unitFilterData = {
          name: this.unitFilterForm.name,
          is_default: (this.unitFilterForm.is_default != null)?this.unitFilterForm.is_default.value:null,
          zoop_anticipation_enabled: (this.unitFilterForm.zoop_anticipation_enabled != null)?this.unitFilterForm.zoop_anticipation_enabled.value:null,
          status: (this.unitFilterForm.status != null)?this.unitFilterForm.status.value:null,
          page: page
        };
        this.api.getUnits(unitFilterData).then(res => {
          this.units = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;

          this.eventBus.$emit('IS_LOADING', false);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Units', res);
        }).catch(err => {
          this.$swal('Ops...', 'Não conseguimos carregar as unidades! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Units', err.response);
        });
      },

      getStatus(unit) {
        if(unit.status == 'INCOMPLETE') {
          // return {name:'Cadastro incompleto', class: 'incomplete'};
          return {name:'Não cadastrado', class: 'incomplete'};
        }
        else if(unit.status == 'pending') {
          return {name:'Em análise', class: 'pending'};
        }
        else if(unit.status == 'enabled' || unit.status == 'active') {
          return {name:'Habilitado', class: 'enabled'};
        }
        else if(unit.status == 'deleted') {
          return {name:'Excluído', class: 'deleted'};
        }
        else {
          return {name:'Desabilitado', class: 'disabled'};
        }
      }
    }
  }
</script>

<style lang="scss">
  .main-content-cj {
    &.unit-list {
      padding: 20px 0;

      .box-cj {
        .content {
          th {
            font-size: 14px;
            color: $cadetGray;
            border-top: 0;
          }

          tbody {
            font-size: 14px;
            color: $waikawaGray;

            .line-add {
              padding: 10px 0;
            }

            tr:nth-child(even) {
              background-color: $whisper;
            }

            tr:nth-child(odd) {
            }

            .unit-status {
              .status-indicator {
                font-size: 14px;

                &.enabled {
                  color: $ufoGreen;
                }
                &.pending {
                  color: $yellowSea;
                }
                &.incomplete {
                  //color: $valencia;
                  color: #6c757d;
                }
                &.deleted {
                  color: $dullRed;
                }
                &.disabled {
                  color: #333333;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
